export default __webpack_public_path__ + "img/7aa95d4.svg";